/*
 * treatment-plan (zod)
 */
import { createInsertSchema, createSelectSchema } from "drizzle-zod"
import * as z from "zod"
import { globalCreateExclude, globalUpdateExclude } from "../utils/constants"
import { treatmentPlans } from "./treatment-plan.schema"

/* Select */
export type TreatmentPlan = z.infer<typeof selectTreatmentPlanSchema>
export const selectTreatmentPlanSchema = createSelectSchema(treatmentPlans)

/* Filters */
export type TreatmentPlanFilters = z.infer<typeof treatmentPlanFiltersSchema>
export const treatmentPlanFiltersSchema = z.object({
	id: z.string().optional(),
	patientId: z.string().optional(),
	isLatest: z.boolean().optional(),
	active: z.boolean().optional(),
})

/* Create */
export const createTreatmentPlanSchema = createInsertSchema(treatmentPlans).partial(globalCreateExclude)
export type CreateTreatmentPlan = z.infer<typeof createTreatmentPlanSchema>

/* Update */
export const updateTreatmentPlanSchema = createInsertSchema(treatmentPlans)
	.omit(globalUpdateExclude)
	.partial()
	.required({ id: true })
export type UpdateTreatmentPlan = z.infer<typeof updateTreatmentPlanSchema>
